class ToolTip extends HTMLDetailsElement {
    constructor() {
        super();
        this.hasHover = window.matchMedia('(hover: hover)').matches;
        this.showDelay = parseInt(this.getAttribute('data-show-delay') || '200');
        this.hideDelay = parseInt(this.getAttribute('data-hide-delay') || '200');
        this.showTimeout = null;
        this.hideTimeout = null;
        this.isClickOpened = false;

        console.log('ToolTip constructor');
    }

    connectedCallback() {
        this.summary = this.querySelector('summary');
        if (!this.summary) {
            console.error('ToolTip: No summary element found.');
            return;
        }

        this.addEventListeners();
    }

    addEventListeners() {
        // Click handling for all devices
        this.summary.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent default details toggle
            if (this.open && this.isClickOpened) {
                this.hide();
            } else {
                this.isClickOpened = true;
                this.show();
            }
        });

        // Hover handling only for devices with hover capability
        if (this.hasHover) {
            this.addEventListener('mouseenter', () => {
                if (!this.isClickOpened) {
                    this.scheduleShow();
                }
            });

            this.addEventListener('mouseleave', () => {
                if (!this.isClickOpened) {
                    this.scheduleHide();
                }
            });

            this.summary.addEventListener('mouseenter', () => {
                if (!this.isClickOpened) {
                    this.scheduleShow();
                }
            });
            /* 
            this.summary.addEventListener('mouseleave', () => {
                if (!this.isClickOpened) {
                    this.scheduleHide();
                }
            }); */
        }

        // Handle click outside
        document.addEventListener('click', (e) => {
            if (this.open && !this.contains(e.target) && this.isClickOpened) {
                this.hide();
            }
        });

        // Handle escape key
        this.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.open) {
                this.hide();
            }
        });

        // Handle focus out
        this.addEventListener('focusout', (e) => {
            if (!this.contains(e.relatedTarget) && this.isClickOpened) {
                this.hide();
            }
        });
    }

    scheduleShow() {
        this.cancelHide();
        this.showTimeout = setTimeout(() => this.show(), this.showDelay);
    }

    scheduleHide() {
        this.hideTimeout = setTimeout(() => this.hide(), this.hideDelay);
    }

    cancelShow() {
        if (this.showTimeout) {
            clearTimeout(this.showTimeout);
            this.showTimeout = null;
        }
    }

    cancelHide() {
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
    }

    show() {
        if (this.open) return;
        this.open = true;
    }

    hide() {
        if (!this.open) return;
        this.open = false;
        this.isClickOpened = false;
    }
}

customElements.define('tool-tip', ToolTip, { extends: 'details' });

export default ToolTip;
